
  import TodoContext from "../todoCtx/TdoCtx";
  import "./compTodoList.css"
  import React, { useContext  } from 'react';
  import moment from 'moment';
  // import { FaArchive } from 'react-icons/fa';
  import { IconContext } from "react-icons/lib";
  import { IoAddCircle,IoBackspace } from "react-icons/io5";
import AddItem from "../addItem/AddItem";
import Box from "../box/Box";
import DoubleTodoList from "../doubleTodoList/DoubleTodoList";
import Students from "../students/Students";

  moment().format();



  const CompTodoList = ({dragItem}) => {

    // const dragItem = useRef();
    // const dragOverCompItem = useRef();

    const {compTodos,todos,setTodos,setCompTodos,crtDrgSection, setCrtDrgSection,compTodos2,setCompTodos2,compTodosMove1,compTodosMove2,setCompTodosMove1,setCompTodosMove2, isShown, setIsShown,data, setData, notAllowed, setNotAllowed,replace, setReplace, copyCounter, setCopyCounter,dblListItems, setDblListItems, showDblList, setShowDblList, dblListItemsSepa, setDblListItemsSepa,replaceTodos, setReplaceTodos, stdClasses, setStdClasses,class8,setClass8,class9,setClass9, showClass9, setShowClass9,showRecycleBin,setShowRecycleBin, showForm, showStudents, storedId, setStoredId, setShowForm} = useContext(TodoContext);

    // const draggable = () => {    onclick wala
    //   setData(!data);
    // };

    // const handleClickAdd = event => {
    //   // 👇️ toggle shown state   
    //   setIsShown(current => !current);
  
    //   // 👇️ or simply set it to true
    //   // setIsShown(true);
    // };

    const handleRecycleBin = (e) => {
      
      console.log("recycle bin handler");      

      setShowRecycleBin(showRecycleBin => !showRecycleBin);
      const newDblList = [...compTodosMove1];

      setDblListItemsSepa(newDblList);


      };




    const dragStartComp = (e, position) => {
      // console.log("dragStartComp function ran")

      dragItem.current = position;

      };


      const dragEnterComp = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("CompTodo:you have entered Completed Todos")


        const compId = e.target.id;
      
        setCrtDrgSection(compId);
        console.log("compId",compId);
        if (e.target.id === "completed")
        setData(!data);
        else{
          console.log("entering in same section");
        }
      }

      const dragLeaveComp = (e) => {
        
        e.preventDefault();
        e.stopPropagation();

        console.log("leave")
        if (e.target.id === "completed"){

          console.log("data before",data);

          setData(false);

          console.log("data after",data);

        }
        else{
          console.log("do not do anyting on leave");


        }

        
      }

      const dragEnterReplace = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("CompTodo:you have entered Completed Todos")

        const compId = e.target.id;
      
        setCrtDrgSection(compId);


        if (e.target.id === "replace")
        setReplace(!replace);
        else{
          console.log("entering in same section");
        }
      }

      const dragLeaveReplace = (e) => {
        
        e.preventDefault();
        e.stopPropagation();

        console.log("leave")
        if (e.target.id === "replace"){

          console.log("data before",data);

          setReplace(false);

          console.log("data after",data);

        }
        else{
          console.log("do not do anyting on leave");


        }

        
      }

      const dragEnterNotAllowed = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("CompTodo:you have entered Completed Todos")

        if (e.target.id === "notAllowed")
        setNotAllowed(!notAllowed);
        else{
          console.log("entering in same section");
        }
      }

      const dragLeaveNotAllowed = (e) => {
        
        e.preventDefault();
        e.stopPropagation();

        console.log("leave")
        if (e.target.id === "notAllowed"){

          console.log("data before",data);

          setNotAllowed(false);

          console.log("data after",data);

        }
        else{
          console.log("do not do anyting on leave");


        }

        
      }

      const dragOverComp = (e) => {

        e.stopPropagation();
        e.preventDefault();

        // e.currentTarget.style.background = '#6357F8';
        }

        const dragOverReplace = (e) => {

          e.stopPropagation();
          e.preventDefault();
  
          // e.currentTarget.style.background = '#6357F8';
          }



          


      // const dragOver = (event) => {
      //   event.preventDefault();
      // }

  // ******************* DROP COPY ****************************

      const dropComp8 = (e) => {
        

        const copyClass8 = [...class8];
        const copyTodos = [...todos];
        

        const todoItem = copyTodos[dragItem.current];
        const todoItemId = todoItem.todoId;

        // const compTodoItem = copyCompTodos[dragItem.current];
        // const compTodoItemId = compTodoItem.todoId;

        console.log("todoItem",todoItem);
        console.log("todoItemId",todoItemId);
        console.log("copyCompTodos",class8);


              e.preventDefault();

              copyTodos.splice(dragItem.current,1);
        
              setTodos(copyTodos);
        
              const newTodos = [ todoItem, ...class8 ];
        
              setClass8(newTodos);

              setClass8(class8 =>

                class8.map( (todo) => 
    
                todo.todoId === todoItemId ? { ...todo, class : "8" } : todo
                
                
                ))

                

                  }

                

        const dropComp9 = (e) => {
        

                    const copyClass8 = [...class9];
                    const copyTodos = [...todos];
                    
            
                    const todoItem = copyTodos[dragItem.current];
                    const todoItemId = todoItem.todoId;
            
                    // const compTodoItem = copyCompTodos[dragItem.current];
                    // const compTodoItemId = compTodoItem.todoId;
            
                    console.log("todoItem",todoItem);
                    console.log("todoItemId",todoItemId);
                    console.log("copyCompTodos",class8);
            
            
                          e.preventDefault();
            
                          copyTodos.splice(dragItem.current,1);
                    
                          setTodos(copyTodos);
                    
                          const newTodos = [ todoItem, ...class9 ];
                    
                          setClass9(newTodos);

                          setClass9(class9 =>

                            class9.map( (todo) => 
                
                            todo.todoId === todoItemId ? { ...todo, class : "9" } : todo
                            
                            
                            ))

                            

                          
            
                              }

          console.log("storedId", storedId);


 


          const dragEnd = (e) => {

            dragItem.current = null;
            console.log("drag end")

          
          }

          const handleClass8 = (event,id) => {
            // 👇️ toggle shown state   
            setShowDblList(showDblList => !showDblList);

            const newDblList = [...class8];

            setDblListItemsSepa(newDblList);

          setShowForm(false);

          


 
      
          };

          const handleClass9 = (event,id) => {
            // 👇️ toggle shown state   
            setShowDblList(showDblList => !showDblList);
            const newDblList = [...class9];
  
            setDblListItemsSepa(newDblList);

          }

          const handleClassClick = (event,classNbr) => {
            // 👇️ toggle shown state   
            setShowDblList(showDblList => !showDblList);
      
            // const copyCompTodos = [...compTodos];
            // const copyTodos = [...todos];
      
            const newTodos = todos.filter(todo => { 
              return todo.classCheck === classNbr}); 
            setDblListItemsSepa(newTodos);
      
            console.log("dblListItemsSepa func",dblListItemsSepa);
            console.log("dblListItems func",dblListItems);
      
          };





// ******************* DROP REPLACE ****************************

      const dropRecycleBin = (e) => {

        const copyCompTodosMove1 = [...compTodosMove1];
        const copyTodos = [...todos];
        const todoItem = copyTodos[dragItem.current]; //arr[0]
        

            if (copyTodos.includes(todoItem) && !replaceTodos.includes(todoItem) ) {

              e.preventDefault();
              copyTodos.splice(dragItem.current,1);
        
              setTodos(copyTodos);
        
              const newTodos = [ ...compTodosMove1, todoItem  ];
        
              setCompTodosMove1(newTodos);
              setReplace(false);
  
            }
        
            else{

              console.log("already there in MOVE");

            }

             

      
    }

    const dropDlt = (e) => {
        

      const copyCompTodos = [...compTodos];
      const copyTodos = [...todos];
      

      const todoItem = copyTodos[dragItem.current];
      const todoItemId = todoItem.todoId;

      console.log("todoItem",todoItem);
      console.log("todoItemId",todoItemId);
      console.log("copyCompTodos",copyCompTodos);


            e.preventDefault();
            

            const newTodos = copyTodos.filter(todo => { 
              return todo.todoId === todoItemId}); 
            setTodos(newTodos);


      


        }

 


                const handleDltMarked = (event, id) => {

                  const newTodos = todos.filter(todo => { 
                    return todo.isMarked === false}); 
                  setTodos(newTodos);
      
            
            
            
                  
                };



      

      
 



  
    return (

      <>

      {/* {isShown && <Box/>} */}

      {(showDblList || showRecycleBin) && <DoubleTodoList/>}

      

      {/* {showClass9 && <Class9/>} */}

      {/* {(!showDblList && !showClass9) */}

      {(!showDblList && !showRecycleBin) && <div className="compTodoListWrapper">

        <div className="compTodoListTitle">
        <h1>CLASSES</h1>
        </div>

        

        <div className="compTodoListsAll">

        <div>





<ul > <div draggable = "false" id="replace" className={replace ? 'replace-active' : 'replace-inactive'}    >   


<div className="moveTodoListItemsContainer">


    <li> <div draggable = "false" className='moveTodoListItem'  id="class8"   onDragEnter={(e) => dragEnterReplace(e)} onDragLeave={(e) => dragLeaveReplace(e)} onDragOver={(e) => dragOverReplace(e)} onDrop={(e) => dropComp8(e)} onClick={event => handleClass8(event,"class8")} 
      > CLASS 8

  </div>
   
    </li>

<li> <div draggable = "false" className='moveTodoListItem'  id="class9"   onDragEnter={(e) => dragEnterReplace(e)} onDragLeave={(e) => dragLeaveReplace(e)} onDragOver={(e) => dragOverReplace(e)} onDrop={(e) => dropComp9(e)} onClick={event => handleClass9(event,"class9")} 
      > CLASS 9

</div>

</li>

    
</div>
</div>    
</ul>

</div>

          {/* <div className="copyDiv"> */}

          <div>





 <div id="replace" className={replace ? 'replace-active' : 'replace-inactive'}  onDragEnter={(e) => dragEnterReplace(e)} onDragLeave={(e) => dragLeaveReplace(e)} onDragOver={(e) => dragOverReplace(e)} onDrop={(e) => dropRecycleBin(e)}  >   

{  compTodosMove1.length > 0 && <div className="replaceCounter">

  {/* <div className="replaceCounterFixed"> */}

  { compTodosMove1.length}

  {/* </div> */}

</div>
}



 
<div className="moveTodoListItemsContainer">

 <div draggable = "false" className='moveTodoListItemRec' 
      > <h5 onClick={e => handleRecycleBin(e)} >Recycle Bin</h5>

  

  </div>



  

</div>

</div>    


</div>



      {/* </div> */}


      {/* ^^^^^^^^^^NEW DROPS^^^^^^^^^^^^^ */}





      <div id="notAllowed" className={notAllowed ? 'notDraggable-active' : 'notDraggable-inactive'} draggable="false" onDragEnter={(e) => dragEnterNotAllowed(e)} onDragLeave={(e) => dragLeaveNotAllowed(e)}>


  </div>

  


      </div>
      
      </div>

      
      
  }
      </>
      )
  }

  export default CompTodoList 